import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="customerRelation";

export function getAllRelationByCustomerId(customerId){
  console.log("-----params:", customerId)
  return axios({
    url: `/ws/${moduleName}/getAllRelationByCustomerId/${customerId}`,
    method: 'get',
  })
}

export default {
  getAllRelationByCustomerId
}
